import predicates from '../predicates'
import selectors from '../selectors'
import { REFERRAL_TRAFFIC_SOURCE } from '../constants'

const referral = {
  rule: predicates.referrerExists(),
  extractor: traffic => {
    const trafficSource = REFERRAL_TRAFFIC_SOURCE
    const trafficId = selectors.referrerHostname(traffic)

    return {
      trafficSource,
      trafficId,
    }
  },
}

export default referral



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/services/trafficAnalyzer/pipelines/referral.js